<template>
	<PublicMenuLayoutV2 invertedColorsMobile>
		<template v-slot:nav-items>
			<b-nav-item class="my-auto" @click="() => { $helpers.goTo360() }">
				<p>{{ $t('patients-layout.openhealth')}}</p>
			</b-nav-item>
			<b-nav-item class="my-auto" @click="() => { $helpers.goToProfessionalsLanding() }">
				<p>{{ $t('professionals') }}</p>
			</b-nav-item>
			<b-nav-item>
				<router-link to="/opensalud360/empresas" tag="p">{{ $t('patients-layout.companies') }}</router-link>
			</b-nav-item>
		</template>
		<template v-slot:nav-btn-items>
			<b-nav-item class="my-auto d-block ml-0 ml-xl-2">
				<router-link to="/inicio-sesion">
					<ArrowButton :text="$t('login-wrd')" :action="() => { $router.push('/inicio-sesion') }" reverse :backgroundColor="BLUE_COLOUR" :textColor="WHITE_COLOUR"/>
				</router-link>
			</b-nav-item>
		</template>
	</PublicMenuLayoutV2>
</template>

<script>
	import PublicMenuLayoutV2 from '@/components/layouts/PublicMenuLayoutV2'
	import ArrowButton from '@/components/base/buttons/ArrowButton'
	import { BNavItem } from 'bootstrap-vue'
	import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'
	import gtagMixin from '@/mixins/gtag.mixin'

	export default {
		name: 'OpensaludLayout',
		mixins: [gtagMixin],
		components: {
			BNavItem,
			PublicMenuLayoutV2,
			ArrowButton
		},
		data () {
			return {
				BLUE_COLOUR,
				WHITE_COLOUR
			}
		},
		methods: {
			goForum () {
				location.href = this.$helpers.getHealthyCommunityUrl('pacientescomotu')
			},
			goToMenttum () {
				window.location = 'https://menttum.com/'
			}
		}
	}
</script>

<style lang="scss" scoped>

@include media(mobile,tablets){
	/deep/ .navbar-nav {
		flex-direction: column-reverse;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/layouts/OpensaludPacientesLayout.vue